import { z } from 'zod';

/**
 * The canonical embedded-customer reference shared across list/detail wire shapes (ADR-0020).
 * The API embeds a customer as a nested object, consistently, on every resource that references
 * one (orders list, order detail, payments list) — the frontend consumes it directly rather than
 * flattening into `customerId`/`customerName`/… prefixes.
 *
 * `avatarUrl` is a presentation concern derived client-side from the name (see `customerAvatar`),
 * so the backend omits it — hence `.nullish()`.
 */
export const customerRefSchema = z.object({
  id: z.string(),
  name: z.string(),
  phone: z.string(),
  avatarUrl: z.string().nullish(),
});

export type CustomerRef = z.infer<typeof customerRefSchema>;
